/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'
import Table from '../../../../components/InternalMenu/ReserveList'

import ReactPaginate from 'react-paginate'

import reserveIcon from '../../../../assets/svg/reservationIcon.svg'

import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  document.title = 'درخواست رزرو'

  const [reserves, setReserves] = useState()
  const [reservesCount, setReservesCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/im/reservation?token=${token}`)
      .then(response => {
        console.log(response)
        setReserves(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setReservesCount(response.data.data.total)
      })
      .catch(error => {
        console.log(error)
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/im/jobs?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setReserves(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setReservesCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'reservation'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={reserveIcon} width={'22px'} alt='resturantIcon' />
              </div>
              <div className='text'>
                درخواست رزرو میز
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل درخواست
              </div>
              <div className="left">
                {reservesCount}
              </div>
            </div>

            <Table data={reserves} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
